<template>
  <div class="codelogin">
    <div>
      <div class="title">
        付费观看
      </div>
      <div class="input_view">
        <img src="../../assets/login/payzw.png" alt="">
      </div>
      <div class="sumbit" @click="gopay">
        立即支付
      </div>
    </div>
    <div class="giftfk" v-if="paycode">
      <div>请用微信扫码支付</div>
      <fkcode :link="payinfo.url"></fkcode>
      <br>
      <span style="color: red;">{{ count }}</span> 秒后自动取消
      <br>
      <br>
      <div style="color:#256EE7;" @click="cancelpay()">取消支付</div>
  </div>
  <div class="mb_giftfk" v-if="paycode">
  </div>
  </div>
</template>
<script>
  import fkcode from '../lives/fkcode'
export default {
  name: 'pwdlogin',
  props: {
    
  },
  components: {
        fkcode
    },
  data() {
    return {
      paycode:false,
      payinfo:{},
      count: 60,
      times: null,
      time:null
    }
  },
  methods: {
    cancelpay() {
            this.count = 60;
            this.paycode = false
            clearInterval(this.time);
            clearInterval(this.times);
        },
        gopay(){
         this.$liveapi.roomwatchytypepay('PC').then(res=>{
          this.paycode = true
          this.times = setInterval(() => {
                this.checkpaytype();
          }, 2000); 
          this.time = setInterval(() => {
                if (this.count <= 0) {
                    clearInterval(this.time);
                    clearInterval(this.times);
                    this.count = 60;
                    this.paycode = false
                    return;
                }
                --this.count;
            }, 1000);
          this.payinfo = res.data.data
         })
        },
        checkpaytype(){
          this.$liveapi.roomwatchytypeverifyPay(this.payinfo.orderNum).then(res=>{
            console.log(res);
            if (res.data.code == 200) {
                    clearInterval(this.times);
                    clearInterval(this.time)
                    this.paycode = false
                    this.count = 60;
                    this.$message({
                        message: "支付成功",
                        type: "success"
                    });
                    setTimeout(() => {
                      location.reload()
                    }, 1000);
                }
            })
          }
    },
 
}
</script>
<style scoped>
.codelogin{
    width: 392px;
    height: 500px;
    box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1500);
    z-index: 2;
    background-color: #fff;
    border-radius: 5px;
}
.title{
  padding-top: 42px;
  font-size: 26px;
  font-weight: 550;
  text-align: left;
  text-indent: 2em;
  /* margin-top: 20px; */
}
.code_view{
  width: 200px;
  height: 200px;
  background: url(../../assets/login/subtract.png);
  background-size: 100%;
  margin: 60px auto;
}
.code_view>img{
  width: 180px;
  height: 180px;
  margin: 20px;
}
.input_view{
  width: 366px;
  margin: 20px auto;
}
.input_view img{
  width: 158px;
  height: 135px;
  margin: 45px auto;
}
.phone_view{
  padding-left: 16px;
  width: 350px;
  height: 56px;
  background: #EFF6FF;
  text-align: left;
  font-size: 20px;
  color: #555555;
  line-height: 56px;
  border-radius: 5px;
}
.input_phone{
  width:250px;
  margin-left: 8px;
  font-size: 18px;
  padding-left: 16px;
  background-color: transparent;
  border: 0;
  outline: transparent;
  border-left: 1px solid #CEE2FF;
}
.smscode_view{
  margin-top: 24px;
  width: 366px;
  height: 56px;
  text-align: left;
  font-size: 20px;
  color: #555555;
  line-height: 56px;
  border-radius: 5px;
}
.code_phone{
  float: left;
  width:214px;
  height: 56px;
  font-size: 18px;
  padding-left: 16px;
  background: #EFF6FF;
  border: 0;
  outline: transparent;
  border-radius: 5px;
}
.smscode_view>div{
  float: right;
  width: 120px;
  height: 54px;
  border-radius: 5px;
  border: 1px solid #4256FB;
  text-align: center;
  color: #4256FB;
  font-size: 18px;
}
.sumbit{
  width: 306px;
  height: 46px;
  background: linear-gradient(171deg, #3EA2FF 0%, #4558FC 100%);
  border-radius: 30px;
  color: #fff;
  font-size: 20px;
  line-height: 46px;
  margin: 55px auto;
  cursor: pointer;
}
.slide_verify{
  position: absolute;
  bottom: 160px;
  z-index: 10;
}
.giftfk {
  background-color: #FFFFFF;
  padding: 50px;
  border-radius: 10px;
  height: 240px;
  width: 180px;
  position: fixed;
  z-index: 100;
  top: 30%;
  right: 41%;
}

.mb_giftfk {
  background-color: #000;
  opacity: 0.6;
  border-radius: 10px;
  position: fixed;
  z-index: 99;
  width: 100vw;
  height: 100vw;
  top: 0;
  right: 0;
}
</style>
